import { FileType } from '@/hooks/useFileLoading';
import { Moment } from 'moment';
import { CustomerPersonTypes } from '../../people/Customers/Customers.enums';

export enum ManagerialIncomeRequestType {
  actualFiscal = 'ActualIncomeFiscal',
  actualIncomeTicketAverageTicket = 'ActualIncomeTicketAverageTicket',
  averageTicketPartsServices = 'AverageTicketPartsServices',
  actualIncomePayablesReceivables = 'ActualIncomePayablesReceivables',
}

export enum AverageTicketOptionType {
  workOrder = 'workOrder',
  sale = 'sale',
  all = 'all',
}

export enum ManagerialIncomeResponseType {
  pdf = 0,
  csv = 1,
}

export interface ManagerialIncomeRequest {
  responseType: ManagerialIncomeResponseType;
  companiesIds: string;
  requestType: ManagerialIncomeRequestType;
  startDate: string;
  endDate: string;
  format: FileType;
  costCenterIds?: string;
  averageTicketOption?: AverageTicketOptionType;
  customerPersonTypes?: CustomerPersonTypes[];
  excludeDirectSaleFromActualIncomeTicket?: boolean;
}

export interface ManagerialIncomeFormValues {
  companiesIds: number[];
  requestType: ManagerialIncomeRequestType;
  initialDate: Moment;
  finalDate: Moment;
  costCenterIds?: number[];
  customerPersonTypes?: CustomerPersonTypes[];
  averageTicketOption?: AverageTicketOptionType[];
  excludeDirectSaleFromActualIncomeTicket?: boolean;
}
